<div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-3">
    <div class="col">
        <div class="card radius-10">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div>
                        <p class="mb-0 text-secondary">Total Team Members</p>
                        <h4 class="my-1">{{projectCard?.totalTeamMembers}}</h4>
                    </div>
                    <div class="widgets-icons bg-light-success text-success ms-auto">
                        <i class='bx bxs-wallet'></i>
                    </div>
                </div>
                <div id="chart1"></div>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="card radius-10">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div>
                        <p class="mb-0 text-secondary">Active Hours</p>
                        <h4 class="my-1">{{projectCard?.totalActiveHours}}</h4>
                    </div>
                    <div class="widgets-icons bg-light-warning text-warning ms-auto">
                        <i class='bx bxs-group'></i>
                    </div>
                </div>
                <div id="chart2"></div>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="card radius-10">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div>
                        <p class="mb-0 text-secondary">Total Open Tasks</p>
                        <h4 class="my-1">{{projectCard?.totalOpenTasks}}</h4>
                    </div>
                    <div class="widgets-icons bg-light-danger text-danger ms-auto">
                        <i class='bx bxs-binoculars'></i>
                    </div>
                </div>
                <div id="chart3"></div>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="card radius-10">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div>
                        <p class="mb-0 text-secondary">Total Closed Tasks</p>
                        <h4 class="my-1">{{projectCard?.totalClosedTasks}}</h4>
                    </div>
                    <div class="widgets-icons bg-light-danger text-danger ms-auto">
                        <i class='bx bxs-binoculars'></i>
                    </div>
                </div>
                <div id="chart4"></div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-12 col-xl-6 d-flex">
        <div class="card radius-10 w-100">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div>
                        <h5 class="mb-0">Teams</h5>
                    </div>
                    <div class="text-center border-dotted ms-auto mt-2">
                        <button type="submit" id="save-btn" class="border-dotted-btn">
                          <span class="text-primary mb-2" (click)="createProject()">New Project</span>
                        </button>
                      </div>
                </div>
            </div>
            <div class="customers-list p-3 mb-3">
                <div class="customers-list-item d-flex align-items-center border-bottom p-2 cursor-pointer"
                    *ngFor="let project of project">
                    <div class="d-flex align-items-center w-100">
                        <img src="assets/images/avatars/avatar-16.png" class="rounded-circle me-2" width="46"
                            height="46" alt="" />
                        <h6 class="mb-0 font-1" style="width:150px">{{ project.name }}</h6>
                        <h6 class="mb-0 font-14" style="width:235px">{{ project.code }}</h6>
                        <!-- <div *ngFor="let member of team.teamMemberDtos" class="d-flex">
                            <h6 class="mb-0 font-14 me-3" ngbTooltip="Members">{{ employeeCount }}</h6>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class=" mt-3 mb-3">
                <a href="#" class="project" routerLink="/project-pilot/projects">
                    View More <i class='bx bx-chevron-right ms-1'></i>
                </a>
            </div>
        </div>
    </div>
</div>